



































import { Component, Prop, Vue } from 'vue-property-decorator';
import recipesDB from '../../server/init';
import { firebaseAuth } from '../../server/init';
import usersDB from '../../server/init';
import slugify from 'slugify';
import moment from 'moment';

@Component({})
export default class EditComment extends Vue {
  @Prop({ type: String, default: '' })
  public activeRecipe!: string;

  @Prop({ type: String, default: '' })
  public activeReviewTitle!: string;

  @Prop({ type: String, default: '' })
  public activeReviewBody!: string;

  @Prop({type: String, default: ''})
  public reviewAuthor!: string;

  @Prop({type: String, default: ''})
  public reviewDate!: string;

  @Prop({})
  public reviews!: any;

  private formValid: boolean = false;

  private data() {
    return {
      commentTitle: this.activeReviewTitle,
      commentTitleError: null,
      commentBody: this.activeReviewBody,
      showBottomSheet: false,
      recipeId: this.activeRecipe,
      reviewsData: this.reviews,
    };
  }


  private validateForm() {
    if (!this.$data.commentTitle && !this.$data.commentBody) {
      this.$data.commentTitleError = 'Please enter a comment.';
      this.formValid = false;
    } else {
      this.formValid = true;
      this.$data.commentTitleError = null;
    }
  }


  private closeSheet() {
    this.$emit('closeBottom');
  }

  private scrollToTop() {
    const content = document.getElementById('add-comment');
    if (content != null) {
      content.scrollIntoView({
        block: 'center',
    });
    }
  }

  private updateComment() {
  // Validate Fields
  this.validateForm();
  // Add to DB
  if (this.formValid === true) {
      this.reviews.forEach((review: any) => {
        if (review.author === this.reviewAuthor && review.date === this.reviewDate) {
          this.$data.reviewsData = this.reviews.splice(review, 1);
          this.$data.reviewsData.push({
            author: this.reviewAuthor,
            body: this.$data.commentBody,
            date: moment().format('MM/DD/YYYY'),
            rank: review.rank,
            rating: review.rating,
            title: this.$data.commentTitle,
          });
          recipesDB.collection('recipes').doc(this.$data.recipeId).update({
          reviews: this.$data.reviewsData,
          })
          .then(() => {
            this.$emit('closeBottom');
            this.$emit('refreshRecipes');
          });
        }
      });
  }
}





private cancelComment() {
  this.closeSheet();
}

}
